// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkReturnLeft: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 10 9" width={width} height={height}>
            <path
                fill="currentColor"
                d="M.105 4.235a.39.39 0 0 0 0 .53L4.034 8.89a.346.346 0 0 0 .504 0 .39.39 0 0 0 0-.53l-3.32-3.485h8.426A.367.367 0 0 0 10 4.5a.367.367 0 0 0-.357-.375H1.219L4.539.64a.39.39 0 0 0 0-.53.346.346 0 0 0-.505 0z"
            />
        </svg>
    );
};

export default React.memo(LinkReturnLeft);
